import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Subscription } from "models/User";
import UpgradePlanFlow from "pages/UpgradePlanFlow";
import { getSubscription } from "services/UserService";
import {
  getSocket,
  getRequestData,
  ACTION_SUBSCRIBE_SUBSCRIPTION_UPDATE,
} from "services/WebSocketService";

import styles from "./SubscriptionPage.module.scss";

const SubscriptionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [workspaceName, setWorkspaceName] = useState<string | null>(null);

  const subscriptionSocket = useMemo(() => {
    if (subscription?.id) return getSocket("subscription");
    return null;
  }, [subscription?.id]);

  // Subscribing to subscription updates
  useEffect(() => {
    if (subscriptionSocket && subscription)
      subscriptionSocket.onopen = (event) => {
        subscriptionSocket.send(
          getRequestData(ACTION_SUBSCRIBE_SUBSCRIPTION_UPDATE, {
            subscription_id: subscription.id,
          }),
        );
      };
  }, [subscription, subscriptionSocket]);

  useEffect(() => {
    if (subscriptionSocket)
      subscriptionSocket.onmessage = (event) => {
        const { data } = JSON.parse(event.data);
        setSubscription(data);
      };

    return () => {
      subscriptionSocket?.close();
    };
  }, [subscriptionSocket]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const workspaceId = searchParams.get("workspaceId");
    const wName = searchParams.get("workspaceName");
    if (wName) setWorkspaceName(wName);

    if (!workspaceId) {
      console.error("WorkspaceId is required!");
      return;
    }
    getSubscription(+workspaceId).then((data) => {
      setSubscription(data);
    });
  }, [location.search]);

  if (!subscription) return null;

  return (
    <div className={styles.container}>
      <UpgradePlanFlow
        subscription={subscription}
        workspaceName={workspaceName}
      />
    </div>
  );
};

export default SubscriptionPage;
